import { render, staticRenderFns } from "./btn-disabled.mpx?vue&type=template&id=4e12f676&isComponent&outputPath=components%2Fbtn-disabled13fdc916%2Findex"
import script from "./btn-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-disabled13fdc916%2Findex"
export * from "./btn-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-disabled13fdc916%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports